import React from 'react';
import {
  FormGroup, ControlLabel, FormControl, HelpBlock,
} from 'react-bootstrap';

export default function renderField({
  input, label, type, meta: { touched, error }, componentClass, placeholder, options, disabled, submitting,
}) {
  // const { disabled, submitting } = this.props;
  const validationState = (touched || type === 'hidden') && error ? 'error' : null;
  return (
    <FormGroup validationState={validationState}>
      {label !== null && label !== undefined && label.length > 0 && <ControlLabel>{label}</ControlLabel>}
      {componentClass !== 'select' && <FormControl {...input} componentClass={componentClass} placeholder={(placeholder || label)} type={type} disabled={(submitting || disabled)} />}
      {componentClass === 'select' &&
        <FormControl {...input} componentClass={componentClass} placeholder={(placeholder || label)} type={type} disabled={(submitting || disabled)}>
          {options !== null && options !== undefined && options.map(option => (<option key={option.value} value={option.value}>{option.label}</option>))}
        </FormControl>
      }
      {type !== 'hidden' && <FormControl.Feedback />}
      {(touched || type === 'hidden') && error && <HelpBlock>{error}</HelpBlock>}
    </FormGroup>
  );
}
